export default "__VITE_ASSET__057cdb06__"